import { Pipe, PipeTransform } from '@angular/core';
import { Role } from '../../../../shared/models/role.model';

@Pipe({
  name: 'searchScope'
})
export class SearchScopePipe implements PipeTransform {

  transform(scopes: Role[], query: string): Role[] {
    if (!query) {
      return scopes;
    }
    return scopes.filter(scope => scope.name.includes(query));
  }

}
